import { EMBEDDED_IN_WEBVIEW_PARAM, MOBILE_SOURCE_PARAM } from '../constants';

export const isInWebView = () => {
  return sessionStorage.getItem(EMBEDDED_IN_WEBVIEW_PARAM) === 'true';
};

// Falls back to 'DESKTOP' when not running in the mobile WebView or when the source param is absent
export const getApplicationSource = () => {
  const source = isInWebView()
    ? (sessionStorage.getItem(MOBILE_SOURCE_PARAM) as 'MOBILE')
    : undefined;

  return source || 'DESKTOP';
};
